import {get} from './axios2'
import {addHeaders} from 'src/utilities/authHeader'

const ptracApiUri = process.env.VUE_APP_PTRAC_API_URI

export async function fetchUser(userId) {
  return await get(`${ptracApiUri}/users/${userId}`, await addHeaders())
}
